var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39208 22.5385V18.8583C8.39206 17.9257 9.19032 17.168 10.1791 17.1622H13.8096C14.8028 17.1622 15.6079 17.9216 15.6079 18.8583V22.5279C15.6079 23.3367 16.2998 23.9941 17.1574 24H19.6343C20.7911 24.0028 21.9016 23.5714 22.7206 22.8008C23.5397 22.0303 24 20.9841 24 19.893V9.43902C24 8.55766 23.5858 7.72166 22.869 7.1562L14.4543 0.809122C12.9834 -0.301053 10.8826 -0.26519 9.45523 0.894461L1.22149 7.1562C0.47083 7.70499 0.0221713 8.54348 0 9.43902V19.8824C0 22.1565 1.95459 24 4.36569 24H6.78605C7.19895 24.0028 7.59598 23.8501 7.88902 23.5757C8.18205 23.3013 8.34685 22.928 8.34684 22.5385H8.39208Z",
    fill: "#A4A9B7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ab160fc3458a4076591fca8a29d061ef.svg";
export { ForwardRef as ReactComponent };